import { uniqueId } from "lodash";
import { PlacesType, Tooltip } from "react-tooltip";
import ReactDOMServer from "react-dom/server";

import "./TooltipWrapper.css";

interface ITooltip {
  content: React.ReactElement | null;
  children: React.ReactElement | string | null;
  place?: PlacesType;
  className?: string;
  as?: "a" | "span" | "div";
}

function TooltipWrapper({
  children,
  content,
  place = "top",
  className = "",
  as = "span",
}: ITooltip) {
  const id = uniqueId("tooltip");
  if (!content) {
    return <div>{children}</div>;
  }

  const Component = as;

  return (
    <>
      <Component
        data-tooltip-id={id}
        data-tooltip-html={ReactDOMServer.renderToStaticMarkup(content)}
        data-tooltip-place={place}
        className={`leading-none ${className}`}
      >
        {children}
      </Component>
      <Tooltip id={id} className="custom-tooltip z-[100]" />
    </>
  );
}

export default TooltipWrapper;
